/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AppReleaseControllerCheck200ResponseData { 
    status?: AppReleaseControllerCheck200ResponseData.StatusEnum;
    platform?: string;
    currentVersion?: string;
    latestVersion?: string | null;
    minSupportedVersion?: string | null;
    storeUrl?: string | null;
    notes?: string | null;
}
export namespace AppReleaseControllerCheck200ResponseData {
    export type StatusEnum = 'ok' | 'update_available' | 'update_required';
    export const StatusEnum = {
        Ok: 'ok' as StatusEnum,
        UpdateAvailable: 'update_available' as StatusEnum,
        UpdateRequired: 'update_required' as StatusEnum
    };
}


